import Header from '@/components/Header';
import Footer from '@/components/Footer';
import EventsHero from '@/components/events/EventsHero';
import CcufsaFeature from '@/components/events/CcufsaFeature';
import EventsPartners from '@/components/events/EventsPartners';
import PastEvents from '@/components/events/PastEvents';

export default function Events() {
  return (
    <main className="min-h-screen bg-background">
      <Header variant="solid" />
      <EventsHero />
      <CcufsaFeature />
      <EventsPartners />
      <PastEvents />
      <Footer />
    </main>
  );
}
